import classNames from 'clsx';
import React from 'react';

import { Icon } from '@swf/sports/components';

import styles from './Title.scss';

interface Props {
  children: React.ReactNode;
  isOpen?: boolean;
  isNested?: boolean;
  isLight?: boolean;
  isDataVis?: boolean;
  hasLink?: boolean;
}

const Title: React.FC<Props> = ({
  children,
  isOpen = false,
  isNested = false,
  isLight = false,
  isDataVis = false,
  hasLink = false
}) => (
  <div
    className={classNames(styles.titleWrapper, {
      [styles.open]: isOpen,
      [styles.isLight]: isLight && isNested,
      [styles.isDataVis]: isDataVis,
      [styles.isNested]: isNested,
      [styles.hasLink]: hasLink
    })}
  >
    <div className={styles.title}>{children}</div>
    {!isNested ? (
      <Icon
        name="chevron-medium-down"
        className={classNames(styles.icon, {
          [styles.iconOpen]: isOpen
        })}
        size="xl"
      />
    ) : null}
  </div>
);

export default Title;
